document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".custom-slider");
  const prevButton = document.querySelector(".slider-prev");
  const nextButton = document.querySelector(".slider-next");
  const dots = document.querySelectorAll(".dot");

  let index = 0;
  let totalSlides = slider.children.length;

  function updateSlide() {
    let offset = index * -100;
    slider.style.transform = `translateX(${offset}%)`;
    dots.forEach(dot => dot.classList.remove("active"));
    dots[index].classList.add("active");
  }

  function slideNext() {
    index = (index + 1) % totalSlides;
    updateSlide();
  }

  function slidePrev() {
    index = (index - 1 + totalSlides) % totalSlides;
    updateSlide();
  }

  function goToSlide(e) {
    index = parseInt(e.target.dataset.index);
    updateSlide();
  }

  nextButton.addEventListener("click", slideNext);
  prevButton.addEventListener("click", slidePrev);
  dots.forEach(dot => dot.addEventListener("click", goToSlide));

  setInterval(slideNext, 7000); // Auto-slide every 5 sec
  updateSlide(); // Initialize
});



$(document).ready(function(){
  $(".also_need .owl-carousel").owlCarousel({
      loop: true,
      nav: true,
     dots: false,
      autoplay: false,
      autoplayTimeout: 5000,
      responsive:{
        0:{
          items: 2,
          margin: 15
        },
        600:{
          items: 3,
          margin: 20
        },
        1000:{
          items: 4,
          margin: 44
        }
      }
    });
  });



$(document).ready(function(){
  $(".explore_collections .owl-carousel").owlCarousel({
      loop: true,
      nav: true,
     dots: false,
      autoplay: false,
      autoplayTimeout: 5000,
      responsive:{
        0:{
          items: 2,
          margin: 10
        },
        600:{
          items: 3,
          margin: 15
        },
        1000:{
          items: 5,
          margin: 25
        }
      }
    });
  });




jQuery(document).ready(function ($) {
  var $first = $(".custom_sidebar h3").first();
  $(".custom_sidebar h3").not($first).removeClass("active").next("ul").hide();
  $first.addClass("active").next("ul").show();
  $(".custom_sidebar h3").click(function () {
    var $this = $(this), $next = $this.next("ul");
    if ($this.is($first)) {
      $this.toggleClass("active");
      $next.slideToggle("fast");
    } else {
      $this.toggleClass("active");
      $next.slideToggle("fast");
      $(".custom_sidebar h3").not($this).not($first).removeClass("active").next("ul").slideUp("fast");
    }
  });
});


$(document).ready(function () {
  var container = $('.collection-hero__description');
  var firstP = container.find('p').first();
  var nextP = firstP.next('p');

if (nextP.length > 0) {
  firstP.nextAll('p').wrapAll('<div class="more-content hidden-item"></div>');

  firstP.after('<a href="#" class="readmore button">Read more</a>');

  container.find('.more-content').append('<a href="#" class="readless button hidden-item">Read less</a>');

  container.on('click', '.readmore', function (e) {
    e.preventDefault();
    container.find('.more-content').slideDown();
    $(this).hide();
    container.find('.readless').removeClass('hidden-item');
  });

  container.on('click', '.readless', function (e) {
    e.preventDefault();
    container.find('.more-content').slideUp();
    container.find('.readmore').show();
    $(this).addClass('hidden-item');
  });
}
});


document.addEventListener("change", () => {
  if (![
    '/products/world-arms-toys-bundle',
    '/products/world-arms-toys-copy',
    '/products/world-arms-toys-kids-cap-guns-copy'
  ].includes(location.pathname)) return;

  document.querySelectorAll('.product-form__input--pill input[type="radio"] + label')
    .forEach(l => l.style.display = "none");

  document.querySelector('.product-form__input--pill input[type="radio"]:checked + label')
    ?.style.setProperty("display", "inline-flex");

});

document.dispatchEvent(new Event("change"));